import { Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { Assessment } from 'types/analysis-result.types';
import PaiListItem from '../../ui/base-components/pai-list-item';

interface Props {
  profileName: string;
  assessment: Assessment | undefined;
}

const CreateManualProfileSuccess: React.FC<Props> = ({ profileName, assessment }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const motiveIllustrationGenerator = () => {
    const baseUrl = '/dashboard/images/illustrations/';

    const motive = assessment?.name || '';

    return `${baseUrl}${_.replace(_.toLower(motive), ' ', '')}.png`;
  };

  return (
    <div className={classes.container}>
      <Typography className={classes.denseTitle}>{profileName}</Typography>
      {!_.isNil(assessment) ? (
        <div className={classes.assessment}>
          {/* upper section */}
          <Typography className={classes.title} align={'center'} textTransform={'uppercase'}>
            {t('personalityType')}
          </Typography>
          <img className={classes.illustration} src={motiveIllustrationGenerator()} alt="motive illustration" />
          <div className={classes.spacer} />

          {/* middle section */}
          <Typography className={classes.title} align={'center'}>
            {assessment.instructions?.descriptions?.shortdescription}
          </Typography>
          {assessment.instructions?.descriptions?.listdescription?.map((item, index) => (
            <PaiListItem key={index} text={item} />
          ))}

          <div className={classes.spacer} />

          {/* bottom section */}
          <Typography className={classes.title} textTransform={'uppercase'}>
            {t('importantToContact', { contactName: assessment.name || t('theContact') })}
          </Typography>
          {assessment.instructions?.descriptions?.importantdescription?.map((item, index) => (
            <PaiListItem key={index} text={item} />
          ))}
        </div>
      ) : null}
    </div>
  );
};

const useStyles = makeStyles()((theme) => ({
  container: {
    width: '100%',
    border: `2px solid ${theme.palette.backgrounds.main}`,
    padding: '20px 96px',
    height: 'calc(100% - 39px - 16px - 20px)',
  },
  assessment: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  illustration: {
    width: 'auto',
    maxHeight: '150px',
  },
  title: {
    width: '100%',
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    marginBottom: '16px',
  },
  denseTitle: {
    fontSize: theme.typography.pxToRem(18),
    marginBottom: '16px',
    textAlign: 'center',
  },
  spacer: {
    height: '16px',
  },
}));

export default CreateManualProfileSuccess;
